module.exports = __webpack_public_path__ + "img/20220109_102751.613edc4e.jpg";